export const REMOVE_GROUP_LOCK_ACTION = 'removeGroupLockAction';
export const SEND_REMOVE_GROUP_LOCK_ACTION = 'sendRemoveGroupLockAction';
export const ADD_GROUP_LOCK_ACTION = 'addGroupLockAction';
export const SEND_ADD_GROUP_LOCK_ACTION = 'sendAddGroupLockAction';
export const GET_GROUP_LOCK_ACTION = 'getGroupLockAction';
export const SEND_GET_GROUP_LOCK_ACTION = 'sendGetGroupLockAction';
export const RECEIVE_MESSAGE_ACTION = 'receiveMessageAction';
